import React, { Component } from 'react'

import { connect } from 'react-redux'

import { LinkContainer } from 'react-router-bootstrap'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { Button, Col, Form, FormControl, FormGroup, Row, DropdownButton, MenuItem } from 'react-bootstrap'
import startCase from 'lodash/startCase'
import Moment from 'moment'
import classNames from 'classnames';

import ToastMessage, { toastify } from './../../components/shared/Toasts';

import * as utils from '../../utils';
import { formatDollars } from '../../utils/utilities'
import featureFlags from '../../utils/featureFlags'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import {getSubmission} from '../api';

import { SubmissionsFilter } from './SubmissionsFilter'

import BrokerageSelectSearchContainer from '../../components/shared/BrokerageSelectSearchContainer'

import { Loading } from '../../components/shared'

import DialogBox from '../../components/shared/DialogBox'
import LinkEdgeNumberModal from './LinkEdgeNumberModal'
import { 
  ChangeQuoteStatusModal,
  QUOTE_STATUS_DECLINED,
  QUOTE_STATUS_BOUND_MANUAL,
  MANUAL_QUOTE_STATUS_OPTIONS
} from './ChangeQuoteStatusModal'
import { SubmissionHistoryModal } from './SubmissionHistoryModal'
import { updateSubmission, unlockBind } from '../actions'

import PDFPreview from './PDFPreview';
import PDFPreviewQuoteSpecimen from './PDFPreviewQuoteSubmission'
import OCPBinder from './OCPBinder';
import { getCurrentSession } from '../../../lib/authentication';
import { fetchBrokerages } from '../../brokerages/actions';

/*
  Broker Columns          Underwriter Columns
  ------------------|------------------------
  Named Insured     |     Named Insured
  Broker (email)    |     Brokerage (Office)
  Type              |     Type
  Status            |     Status
  Total Premium     |     Total Premium
  Commission        |     Commission
  Submitted         |     Submitted
  Last Updated      |     Last Updated
*/

const EDGE_MODEL_DIALOG = 'edgeModel';
const QUOTE_STATUS_DIALOG = 'statusModal';
const DENY_SUBMISSION_ACCESS_DIALOG = 'DENY_SUBMISSION_ACCESS_DIALOG';
const SUBMISSION_HISTORY_DIALOG = 'SUBMISSION_HISTORY_DIALOG';
const STATE_CLOSED = 'CLOSED'
const STATE_OPEN = 'OPEN'
const QUOTE_STATUS_PENDING = 'PENDING'
const QUOTE_STATUS_REFERRED = 'REFERRED'
const QUOTE_STATUS_DRAFT = 'DRAFT'

const DECLINED_MODAL_MSG = `The account you are attempting to make changes to has been declined; 
  therefore, no changes are permitted.  Please reach out to your Underwriter with any questions.`;

const BOUND_MODAL_MSG = `The account you are attempting to make changes to has been bound; therefore, 
no changes are permitted.  Please reach out to your Underwriter with any questions.`;

const formatDollarsData = cell => formatDollars(cell, 'N/A', true)
const formatCommissionData = cell => (cell ? `${cell}%` : '')
const formatUppercaseData = cell => (cell || '').toUpperCase()
const formatWrapping = cell => <div className="multiline">{cell}</div>
const formatAddress = cell => <div className="preline">{cell}</div>
const formatWrappingDate = cell => formatWrapping(Moment(cell).format('MMM Do YYYY h:mma'));

const getRenderStatusClose = (workflowStatusChange = [], row) => {
  const statusChangeItem = workflowStatusChange.find(item => item.id === row.id)
  if (statusChangeItem && statusChangeItem.workflowStatus != row.workflowStatus) {
    return statusChangeItem.workflowStatus === STATE_CLOSED
  } else {
    return row.workflowStatus === STATE_CLOSED
  }
}

const getRenderStatusBind = (bindStatusChange = [], row) => {
  const statusChangeItem = bindStatusChange.find(item => item.id === row.id)
  if (statusChangeItem && statusChangeItem.isBinded != row.isBinded) {
    return statusChangeItem.isBinded
  } else {
    return row.isBinded
  }
}
const getRenderStatusBindSaved = (bindStatusChange = [], row) => {
  const statusChangeItem = bindStatusChange.find(item => item.id === row.id)
  if (statusChangeItem && statusChangeItem.isBinderSaved !== undefined && !row.bindInitiated) {
    return statusChangeItem.isBinderSaved
  } else if (row.bindInitiated  && row.bindInitiated !=false) {
    return !!row.bindInitiated
  } else {
    return row.isBinded
  }
}

const getManualQuotesStatusForRow = (manualQuoteStatusUpdatedList = [], row) => {
  const manualQuoteStatusItem = manualQuoteStatusUpdatedList.find(item => item.id === row.id)
  if (manualQuoteStatusItem && manualQuoteStatusItem.status !== row.manualQuoteStatus) {
    return manualQuoteStatusItem.status
  } else {
    return row.manualQuoteStatus
  }
}

const toastErrorMessage = (
  <ToastMessage icon="exclamation">
      Something Appears to be Wrong. <br />
      Please try again or contact your underwriter
  </ToastMessage>
);

class SubmissionsListFeedTable extends Component {
  constructor(props) {
    super(props)

    this.selectRef = null

    this.handleClearButtonClick = this.handleClearButtonClick.bind(this)
    this.setSelectRef = this.setSelectRef.bind(this)
    this.getSelectRef = this.getSelectRef.bind(this)
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseOut = this.handleCloseOut.bind(this);
    this.handleReOpen = this.handleReOpen.bind(this);
    this.handlepdf = this.handlepdf.bind(this);
    this.handleQuotepdf = this.handleQuotepdf.bind(this);
    this.handleUnbind = this.handleUnbind.bind(this);
    this.handleShowUnBindModel = this.handleShowUnBindModel.bind(this);
    this.handleCloseUnBindModal = this.handleCloseUnBindModal.bind(this);
    this.handleHidePdf = this.handleHidePdf.bind(this);
    this.handleConfirmUnBindModal = this.handleConfirmUnBindModal.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.checkSortOrder = this.checkSortOrder.bind(this);
    this.handleQuoteStatusShowModal =  this.handleQuoteStatusShowModal.bind(this);
    this.state = {
      showModal: false,
      selectedSubmission: {},
      selectedBroker: {},
      dialogType: '',
      modelTitle: '',
      modelUnBindTitle: '',
      showUnBindModal: false,
      selectedUnBindModelId: '',
      selectedSubmissionRow: null
    }
    this.initialState={
      isClicked:false,
      submissionid:'',
      showPdf:false,
      isClickedQuote:false,
      isClickedOcp:false,
      isActiveBrokerage: '',
      submission:{},
      selectedSort: 'updatedAt',
      selectedSortOrder: 'desc'
    }
    this.state=this.initialState;
  }
  componentDidMount() {
    if (!this.props.isUnderwriter) {
      this.props.fetchBrokerages();
    }
  }
  redirectCoverage = (isSelectedCoverage, cell, effDate, finishDate, row) => {
    let _90backday = new Date();
      const eff_Date = new Date(effDate).getTime();
      const finish_Date = new Date(finishDate).getTime();
      const curr_Date = new Date().getTime();
    _90backday = new Date().setDate(_90backday.getDate()-91);
    const isValidEffDate= this.props.isUnderwriter && isSelectedCoverage && ((eff_Date > _90backday) && (finish_Date > curr_Date));
    if(isValidEffDate){
      return (<LinkContainer   to={`/quote/${cell}`}><MenuItem>
      Selected Coverage
    </MenuItem>
  </LinkContainer>)
    }
    return (<LinkContainer   to={`/submission/${cell}`}><MenuItem>
      Selected Coverage
    </MenuItem>
  </LinkContainer>)
  }

  formatQuoteStatusData = (cell, row) => {
    let statusDisplay = '';
    let statusOptions = this.props.isUnderwriter ? [...MANUAL_QUOTE_STATUS_OPTIONS] : [];
    const { bindStatusChange, manualQuoteStatusUpdatedList } = this.props
    const renderStatusBind = getRenderStatusBind(bindStatusChange, row);
    const renderStatusBindSaved = getRenderStatusBindSaved(bindStatusChange, row);
    const manualQuoteStatus = getManualQuotesStatusForRow(manualQuoteStatusUpdatedList, row);
    let manualQuoteStatusItem = null;

    if (typeof manualQuoteStatus === 'string' && manualQuoteStatus.length > 0) {
      manualQuoteStatusItem = MANUAL_QUOTE_STATUS_OPTIONS.find(item => item.code === manualQuoteStatus);
    }
     
    if (manualQuoteStatusItem !== null && manualQuoteStatusItem !== undefined) {
      statusDisplay = manualQuoteStatusItem.display; // manualQuoteStatus takes precedence
    } else if (renderStatusBind) {
      statusDisplay = 'Bound';
    } else if (renderStatusBindSaved) {
      statusDisplay = <span>Bind<br />Incomplete</span>;
    } else if (cell === 'DRAFT') {
      statusDisplay = <span>Not<br />Quoted</span>;
    } else {
      statusDisplay = startCase((cell || '').toLowerCase());
    }

    if (!this.props.isUnderwriter || (statusOptions.length === 0 && !renderStatusBind)) return statusDisplay;

    return <button className="btn-link link-modal" onClick={() => { this.handleQuoteStatusShowModal(row, QUOTE_STATUS_DIALOG, renderStatusBind) }} >{statusDisplay}</button>
  }

  formatActionColumn = (cell, row) => {
    const { isUnderwriter, workflowStatusChange, bindStatusChange, brokerages } = this.props
    const { quoteStatus, updatedAt } = row;
    const downloadQuote = (quoteStatus === QUOTE_STATUS_PENDING) || (quoteStatus === QUOTE_STATUS_DRAFT) || (row.transactionStatus === 'IP') || ((quoteStatus === QUOTE_STATUS_REFERRED) && !isUnderwriter) ? false : true
    const editIcon = (<span className="editButton bold"><i className="fa fa-edit" aria-hidden="true" /> Edit <i className="fa fa-angle-down" aria-hidden="true" /> </span>);
    const renderStatusClose = getRenderStatusClose(workflowStatusChange, row)
    const renderStatusBind = getRenderStatusBind(bindStatusChange, row);
    const allFormsDate = new Date(2020,10,23);
    const quoteDate =  new Date(updatedAt);
    const downloadAllForms = quoteDate >= allFormsDate;
    const downloadIcon = (<i className="fa fa-download" title="Download Quote" aria-hidden="true" />);
    let isActiveBrokerage = brokerages && brokerages.items.length > 0 ? brokerages.items.find(brokerage => brokerage && brokerage.agencyCode === row.agencyCode) : undefined;
            isActiveBrokerage = !!isActiveBrokerage;
    const disableActionDropDown = renderStatusBind; 
    return (
      <ul className="operation-list" style={{fontSize: '13px'}}>
        {!renderStatusClose &&
          <div>
            <li className="sub-menu" onClick={(e) => disableActionDropDown && this.validateEdit(e, row, false, renderStatusBind)}>
            <DropdownButton className="btn btn-link" disabled={disableActionDropDown} title={editIcon} id="splitButtonMenu">
                {this.props.isUnderwriter ? <LinkContainer to={`/submission/${cell}`}>
                  <MenuItem> Submission Details </MenuItem>
                </LinkContainer> : <LinkContainer onClick={(e) => this.validateEdit(e, row, true, false)} to={`/submission/${cell}`}>
                  <MenuItem> Submission Details </MenuItem>
                </LinkContainer>}
                { this.props.isUnderwriter ? this.redirectCoverage(true, cell, row.anticipatedStartDate, row.anticipatedFinishDate, row) : <LinkContainer onClick={(e) => this.validateEdit(e, row, true, false)} to={`/quote/${cell}`}>
                  <MenuItem>
                    Selected Coverage
                  </MenuItem>
                </LinkContainer>}
                {row.type== "ocp" && row.quoteStatus== "PRICED" &&
                  <MenuItem onClick={(e) => this.validateEdit(e, row, false, false) === false ? false : this.handleOcpBind(row.id, '', isActiveBrokerage)}>
                    Start OCP Binder 
                  </MenuItem>
                }
              </DropdownButton>
            </li>
            {downloadQuote && downloadAllForms ?
              <li className="sub-menu dwnld-btn" >
              
                <DropdownButton className="btn btn-link" title={downloadIcon} id="splitButtonMenu">
                  <MenuItem className="sub_mnu" >
                    <Button onClick={(event) => this.validateEdit(event, row, false, renderStatusBind) === false ? false : this.downloadQuote(event, row.id)}> Download Quote </Button>
                    <Button onClick={(event) => this.validateEdit(event, row, false, renderStatusBind) === false ? false : this.handlepdf(row.id)} >

                      <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>

                    </Button>
                  </MenuItem>
                  <MenuItem className="sub_mnu">
                    <Button onClick={(event) => this.downloadQuoteSpecimen(event, row.id)} > Download Policy Specimen</Button>

                    <Button onClick={(event) => this.handleQuotepdf(row.id)} >

                      <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>

                    </Button>
                  </MenuItem>
                  {this.props.isUnderwriter && <MenuItem className="sub_mnu">
                    <Button onClick={() => this.handleShowHistoryModal(row.id)} >History</Button>
                  </MenuItem>}
                </DropdownButton>
              </li>
              : downloadQuote &&
              <li><Button onClick={(event) => this.downloadQuote(event, row.id)}><i className="fa fa-download" title="Download Quote" aria-hidden="true" /></Button></li>
            }
            {renderStatusBind ?
              isUnderwriter && <li><Button onClick={(event) => this.handleShowUnBindModel(row.id)}><i className="fa fa-unlock" title="Unlock Bind" aria-hidden="true" /></Button></li>
              :
              <li><Button className="state-change-button pn mn" onClick={(e) => this.validateEdit(e, row, false, renderStatusBind) === false ? false : this.handleCloseOut(cell, row.brokerEmail) }><i className="fa fa-times-circle" title="Close-out submission" aria-hidden="true" /></Button></li>
            }
          </div>
        }
        {renderStatusClose &&
          <li><Button className="state-change-button" onClick={(e) => this.validateEdit(e, row, false, renderStatusBind) === false ? false : this.handleReOpen(cell) }>Re-open</Button></li>
        }
      </ul>
    )
  }

  normalizeData(data) {
    return data.map((
      { node: { id, bindInitiated, isBinded, projectAddress: { address: projectAddress, city: projectCity, state: projectState }, primaryInsuredName, projectName, type, quoteStatus, manualQuoteStatus, primaryPolicyNumber, totalPremium, commission, contactInfo: { email: brokerEmail }, brokerage: { agencyCode, name: agencyName }, createdAt, edgeNumber, workflowStatus, updatedAt, anticipatedStartDate, anticipatedFinishDate, transactionStatus } }
    ) => {
      let restOfAddress = projectCity.concat(',', ' ', projectState);
      let Address = projectAddress.concat('\n', restOfAddress);
      return { id, bindInitiated, isBinded, Address, primaryInsuredName, projectName, agencyCode, agencyName, brokerEmail, type, quoteStatus, manualQuoteStatus, primaryPolicyNumber, totalPremium, commission, createdAt, edgeNumber, workflowStatus, updatedAt, anticipatedStartDate, anticipatedFinishDate, transactionStatus }
    })
  }

  renderToolbarPanel(props) {
    return (
      <Col key="table-toolbar-panel-left" xs={12}>
        {props.components.searchPanel}
      </Col>
    )
  }

  setSelectRef(element) { this.selectRef = element }
  getSelectRef() { return this.selectRef }

  handleShowModal(row, type) {
    if (type === EDGE_MODEL_DIALOG) {
      let response;
      Promise.all([getSubmission(this.props.user, { id: row.id }), getCurrentSession()])
      .then((results) => {
        let idToken;
        [ response, { idToken }] = results;
        const apiClient = apigClientFactory.newClient();
        return apiClient.apiGetBrokerIdGet(
          { id: response.data.brokerId },
          {},
          {
            headers: {
                Authorization: idToken
            }
          });
      })
      .then((brokerResponse) => {
          this.setState({ selectedSubmission: response.data, selectedBroker: brokerResponse.data.data });
      })
      .catch((error) => {
        console.error(error)
      })
    }

    this.setState({
      showModal: true,
      dialogType: type,
      modelTitle: 'Link to EDGE Submission'
    })
  }

  handleQuoteStatusShowModal(row, type, isBound) {
    const modalTitle = 'Change Status Manually';
    this.setState({
      showModal: true,
      dialogType: type,
      modelTitle: modalTitle,
      selectedSubmissionRow: row.id,
      statusModalIsSystemBound: isBound
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
      selectedSubmission: this.props.isUnderwriter? this.state.selectedSubmission : {},
      dialogType: '',
      modelTitle: ''
    })
    this.props.refetchSubmissions()
    this.props.fetchClearedSubmissions()
  }

  handleShowUnBindModel(id) {
    this.setState({
      showUnBindModal: true,
      modelUnBindTitle: 'Unlock this submission?',
      selectedUnBindModelId: id
    })
  }

  handleCloseUnBindModal() {
    this.setState({
      showUnBindModal: false,
      modelUnBindTitle: '',
      selectedUnBindModelId: ''
    })
  }


  handleHidePdf() {
     this.setState(this.initialState);
  }

  handleConfirmUnBindModal() {
    this.handleUnbind(this.state.selectedUnBindModelId);
    this.handleCloseUnBindModal();
  }

  linkToModalButton = (cell, row) => {
    return (
      <button className="btn-link link-modal" onClick={() => { this.handleShowModal(row, EDGE_MODEL_DIALOG) }} >{cell || 'missing'}</button>
    )
  }

  /**
   * @param {Object} event
   * @param {Object} row
   * @param {Boolean} validateExpired Pass true to display deny access popup for expired submissions
   * @param {Boolean} isSystemBound Pass bound parameter to display deny access popup if submission is a normal system bind.
   * Applies to Brokers only.
   */
  validateEdit = (event, row, validateExpired = false, isSystemBound = false) => {
    let showModal = false;
    let dialogType = '';
    let modelTitle = '';
    if (row.manualQuoteStatus === QUOTE_STATUS_DECLINED && !this.props.isUnderwriter) {
        showModal = true;
        dialogType = DENY_SUBMISSION_ACCESS_DIALOG;
        modelTitle = DECLINED_MODAL_MSG;
    } else if (
      (row.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL && !this.props.isUnderwriter) ||
      (!this.props.isUnderwriter && isSystemBound)
    ) {
        showModal = true;
        dialogType = DENY_SUBMISSION_ACCESS_DIALOG;
        modelTitle = BOUND_MODAL_MSG;
    } else if (validateExpired && utils.submission.hasExpired(row.updatedAt)) {
        showModal = true;
        dialogType = DENY_SUBMISSION_ACCESS_DIALOG;
        modelTitle = 'Submission has expired due to inactivity. Please re-enter through clearance';
    }

    if (showModal) {
      event.preventDefault();
      this.setState({
        showModal: showModal,
        dialogType: dialogType,
        modelTitle: modelTitle
      })
      return false
    }
  }

  downloadQuote = (event, id) => this.props.getDownloadQuoteSubmission(this.props.user, id)

  downloadQuoteSpecimen = (event, id) => {
    getSubmission(this.props.user,{id: id}).then(res => {
      let autoGeneratedOrNonDeduct = true;
      if (res && res.data && !res.data.excessOnly && res.data.coverages && res.data.coverages.gl.base === 'deductibleWarranty') {
        if (res.data.manuallySetPricing === 'true') {
          autoGeneratedOrNonDeduct = false;
        }
        this.props.getDownloadQuoteSpecimenSubmission(this.props.user, id, true, true)
      }
      if (autoGeneratedOrNonDeduct) {
        this.props.getDownloadQuoteSpecimenSubmission(this.props.user, id, false, false)
      }
    })
  }
  
  handlepdf = (id) => {
    this.setState({
      submissionid: id,
      isClicked: true,
      showPdf:true
      
    })
    

  }
  handleQuotepdf = (id) => {
    this.setState({
      submissionid: id,
      isClickedQuote: true, 
      showPdf: true,
    });

  }
  handleOcpBind = (id, errorFlag, isActiveBrokerage = true) => {
    if(id){
     getSubmission(this.props.user,{id: id}).then((response) => {
      this.setState({submission: response.data, isClickedOcp: true,submissionid : id,  isActiveBrokerage})
    }).catch((error) => {
      console.log(error);
    })
  }
  else{
    if(errorFlag) {
      toastify.error(toastErrorMessage);
    } else {
    this.setState({
      submission: '',
      submissionid:'',
    })
    this.props.refetchSubmissions();
  }
  }
  }
  

  handleUnbind = (id) => {
    this.props.unlockBind(id, { isBinded: false }, this.props.user, this.props.refetchSubmissions)
  }

  /**
   * This is seriously the worst.
   * React Bootstrap Table obfuscates its controls so much that we have to do some
   * deep-diving to set refs on controls that we shouldn't have to.
   * Yet here we are.
   * @param {function} clearSearch
   * @param {function} filterChange
   */
  handleClearButtonClick(clearSearch, productTypeChange) {
    const getSelectRef = this.getSelectRef

    return () => {
      getSelectRef().selectedIndex = 0
      productTypeChange('')
      clearSearch()
    }
  }

  handleCloseOut(id, email) {
    this.props.updateSubmission(id, { workflowStatus: STATE_CLOSED }, this.props.user, this.props.refetchSubmissions)
  }

  handleReOpen(id) {
    this.props.updateSubmission(id, { workflowStatus: STATE_OPEN }, this.props.user, this.props.refetchSubmissions)
  }

  handleShowHistoryModal(id) {
    this.setState({
      showModal: true,
      dialogType: SUBMISSION_HISTORY_DIALOG,
      modelTitle: 'Submission History',
      selectedSubmissionRow: id
    });
  }

  checkSortOrder(param) {     
    if(param === this.state.selectedSort && this.state.selectedSortOrder === "desc") {
      return <i className={classNames('fa', 'fa-arrow-down', {'redHighlight': param === this.state.selectedSort}, 'sortIcon')} onClick={()=> this.handleSort(param, "asc")}></i>;
    } else if (param === this.state.selectedSort && this.state.selectedSortOrder === "asc")
    return <i className={classNames('fa', 'fa-arrow-up', {'redHighlight': param === this.state.selectedSort}, 'sortIcon')} onClick={()=> this.handleSort(param, "desc")}></i>;
    else return <i className={classNames('fa', 'fa-arrow-down', 'sortIcon')} onClick={()=> this.handleSort(param, "asc")}></i>;
  }

  handleSort(field, order) {
    this.setState({
      selectedSort: field,
      selectedSortOrder: order
    },() => this.props.onSortChange(field, order))
  }
  renderFilters() {
    const {
      isUnderwriter,
      onChangeIsMissingEdgeNumber,
      onChangeIsActive,
      onChangeIsPriced,
      onChangeIsReferred,
      onChangeIsExpired,
      onChangeIsPending,
      onChangeIsUnknown,
      onChangeIsNotQuoted,
      onChangeIsProcessed,
      onChangeIsExpiringSoon,
      onChangeIsMine,
      onBrokerIdChange,
      brokerId,
      isMissingEdgeNumber,
      isMine,
      isActive,
      isPriced,
      isReferred,
      isExpired,
      isPending,
      isUnknown,
      isNotQuoted,
      isProcessed,
      isExpiringSoon,
      phrase,
      onSearchChange } = this.props

    const filterIsActive = isNotQuoted || isActive || isProcessed || isMine || isMissingEdgeNumber || brokerId || isExpiringSoon || isExpired || isPending || isPriced || isReferred || isUnknown;
    return (
      <div id="submissions-list-feed-table-filters">
        <Row>
          <Col md={2} id="searchBox">
            <Form onSubmit={event => event.preventDefault()} inline className={"pb-x2 pl-x2 " + (phrase ? 'active' : 'border')}>
              <h4>Search</h4>
              <FormGroup bsSize="small">
                <FormControl
                  type="text"
                  placeholder="Search..."
                  value={phrase || ''}
                  onChange={event => onSearchChange(event.target.value)}
                />
              </FormGroup>
            </Form>
          </Col>
          <Col md={10} id="filters">
            <Form onSubmit={event => event.preventDefault()} inline className={"pb-x2 pl-x2 " + (filterIsActive ? 'active' : 'border')}>
              <h4>Filters</h4>
              <Row>
                {isUnderwriter &&
                  <Col md={11} style={{paddingBottom: '10px'}}>

                        <BrokerageSelectSearchContainer
                          value={brokerId}
                          onChange={option => onBrokerIdChange((option && option.value) ? option.value : option)}
                        />
                      </Col>
                }
                <Col md={12} style={{maxWidth: '93%'}}>
                <Row>
                {isUnderwriter && <Col xs={2} className="pn" style={{marginLeft: '-13px'}}>
                        <SubmissionsFilter onChange={onChangeIsMissingEdgeNumber} checked={isMissingEdgeNumber}>
                          EDGE no Missing
                        </SubmissionsFilter>
                </Col>}
                <Col xs={2} className="pn">
                  <SubmissionsFilter onChange={onChangeIsExpiringSoon} checked={isExpiringSoon}>
                    Expiring Soon
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className="pn">
                  <SubmissionsFilter onChange={onChangeIsMine} checked={isMine}>
                    My Submissions
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className="pn">
                  <SubmissionsFilter onChange={onChangeIsActive} checked={isActive}>
                    Active
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className="pn">
                  <SubmissionsFilter onChange={onChangeIsNotQuoted} checked={isNotQuoted}>
                    Not Quoted
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className="pn">
                  <SubmissionsFilter onChange={onChangeIsProcessed} checked={isProcessed}>
                    Binding/Bound
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className={classNames("pn", {"secondRow" : isUnderwriter})}>
                  <SubmissionsFilter onChange={onChangeIsUnknown} checked={isUnknown}>
                    Unknown
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className={classNames("pn", {"secondRow" : isUnderwriter})}>
                  <SubmissionsFilter onChange={onChangeIsPriced} checked={isPriced}>
                    Priced
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className={classNames("pn", {"secondRow" : isUnderwriter})}>
                  <SubmissionsFilter onChange={onChangeIsReferred} checked={isReferred}>
                    Referred
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className={classNames("pn", {"secondRow" : isUnderwriter})}>
                  <SubmissionsFilter onChange={onChangeIsExpired} checked={isExpired}>
                    Expired
                  </SubmissionsFilter>
                </Col>
                <Col xs={2} className={classNames("pn", {"secondRow" : isUnderwriter})}>
                  <SubmissionsFilter onChange={onChangeIsPending} checked={isPending}>
                    Pending
                  </SubmissionsFilter>
                </Col>
                </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    )
  }

  activeSearch = () => {
    const { phrase, isExpiringSoon, isActive, isNotQuoted, isProcessed, isMine, isMissingEdgeNumber, isPending, isExpired, isPriced, isReferred, isUnknown, brokerId, loading, brokerages } = this.props

    if (phrase) {
      return phrase.trim()
    }

    const filters = [
      brokerId && (brokerages.items.find(({ brokerId: id }) => (brokerId === id)).name || '').trim(),
      isMissingEdgeNumber && 'EDGE no Missing',
      isExpiringSoon && 'Expiring Soon',
      isMine && 'My Submissions',
      isActive && 'Active Submissions',
      isNotQuoted && 'Not Quoted',
      isProcessed && 'Binding/Bound Submissions',
      isPriced && 'Priced Submissions',
      isReferred && 'Referred Submissions',
      isPending && 'Clearance Pending Submissions',
      isExpired && 'Expired Submissions',
      isUnknown && 'Unknown Submissions'
    ].filter(Boolean)

    return filters.length && filters.join(', ').trim() || 'All'
  }

  renderFiltersCount = () => {
    const result = this.activeSearch();
    return (
      <div>
        {result && (
          <div className="pull-left">
            <span className="pr">Showing result for &quot;<b>{result}</b>&quot;</span>
            <Button className="btn btn-default btn-link pn" onClick={this.props.getDefaultSearch}>Reset default</Button>
          </div>)}
        <div className="pull-right">
          {this.filterMatchingCount()}
        </div>
      </div>
    );
  }

  filterMatchingCount = () => {
    if (loading) return null

    const { totalCount, currentPage, sizePerPage, loading } = this.props
    const items = totalCount === 1 ? 'item' : 'items';
    const startIndex = (currentPage - 1) * sizePerPage;
    const endIndex = Math.min(startIndex + sizePerPage - 1, totalCount - 1);

    return <span>Showing {startIndex + 1}-{endIndex + 1} of {totalCount} {items}</span>
  }

  renderNoDataText() {
    return (
      <p>
        <strong>Current filters return 0 results</strong>
        <Button className="btn btn-default btn-link pn" onClick={this.props.resetAllFilters}>Show all submissions</Button>
      </p>
    )
  }

  render() {
    const { loading, error, isUnderwriter, onSearchChange, onPageChange, phrase, totalCount: dataTotalSize, sizePerPage, currentPage: page, data, } = this.props
    const submissions = this.normalizeData(data)
    console.log(submissions)
    const tableOptions = {
      sizePerPage,
      onPageChange,
      page,
      onSearchChange,
      noDataText: this.renderNoDataText(),
      hideSizePerPage: true,
      defaultSortName: 'updatedAt',
      defaultSortOrder: 'desc',
    }

    const filters = this.renderFilters()
    const filtersCount = this.renderFiltersCount();
    
    return (
      <div>
        {filters}
        {filtersCount}
        <div className="submissions-list-table">
          <Row>
            <Col xs={12} className="button-column">
              {loading && <Loading width="22px" height="22px" />}
            </Col>
          </Row>

          <div className="submissions-table filter-response pt-x2" >
            <BootstrapTable
              data={submissions}
              options={tableOptions}
              fetchInfo={{ dataTotalSize }}
              remote
              pagination
              hover
              bordered
              condensed
              striped
              headerStyle={{width: '100%', overflow: 'unset !important'}}
              tableStyle={{width: '100%', overflowX: "auto"}}
            >
              <TableHeaderColumn isKey dataField="id" dataFormat={this.formatActionColumn} headerAlign="center"  dataAlign="center" width="120px">Action(s)</TableHeaderColumn>
              <TableHeaderColumn className="header" dataField="primaryInsuredName" dataFormat={formatWrapping} columnClassName="bold" width="150px">Named Insured {this.checkSortOrder("primaryInsuredName")}</TableHeaderColumn>
              <TableHeaderColumn dataField="Address" dataFormat={formatAddress} columnClassName="home-upgrade" width="150px">Project Address</TableHeaderColumn>
              <TableHeaderColumn dataField="projectName" dataFormat={formatWrapping} columnClassName="bold" dataAlign="center" width="100px">Project Name</TableHeaderColumn>
              <TableHeaderColumn dataField="agencyName" dataFormat={formatWrapping} hidden={!isUnderwriter} columnClassName="home-upgrade" width="220px">Brokerage</TableHeaderColumn>
              <TableHeaderColumn dataField="brokerEmail" hidden={isUnderwriter} width="250px">Broker</TableHeaderColumn>
              <TableHeaderColumn dataField="type" dataFormat={formatUppercaseData} headerAlign="left" dataAlign="center" width="60px">Product</TableHeaderColumn>
              <TableHeaderColumn dataField="quoteStatus" dataFormat={this.formatQuoteStatusData} columnClassName="bold" dataAlign="center" width="75px">Status</TableHeaderColumn>
              <TableHeaderColumn dataField="primaryPolicyNumber" dataFormat={formatWrapping} hidden={!isUnderwriter} dataAlign="center" columnClassName="home-upgrade" width="130px">Primary <br />Policy Number{this.checkSortOrder("primaryPolicyNumber")}</TableHeaderColumn>
              <TableHeaderColumn dataField="totalPremium" dataFormat={formatDollarsData} headerAlign="center" dataAlign="right" width="90px">Total <br />Premium{this.checkSortOrder("basePremium")}</TableHeaderColumn>
              <TableHeaderColumn dataField="commission" dataFormat={formatCommissionData} headerAlign="left" dataAlign="center" width="100px">Commission{this.checkSortOrder("commission")}</TableHeaderColumn>
              <TableHeaderColumn dataField="createdAt" dataFormat={formatWrappingDate} headerAlign="center" dataAlign="center" width="110px">Cleared Date{this.checkSortOrder("createdAt")}</TableHeaderColumn>
              <TableHeaderColumn dataField="updatedAt" dataFormat={formatWrappingDate} headerAlign="center" dataAlign="center" width="110px">Last Modified <br />Date{this.checkSortOrder("updatedAt")}</TableHeaderColumn>
              <TableHeaderColumn dataField="edgeNumber" hidden={!isUnderwriter} dataFormat={this.linkToModalButton} dataAlign="center" width="105px">EDGE <br />Submission #{this.checkSortOrder("edgeNumber")}</TableHeaderColumn>
            </BootstrapTable>
          </div>
          <DialogBox
            title={this.state.modelTitle}
            show={this.state.showModal}
            onHide={this.handleCloseModal}
            custom_class='historyPage'
          >
            {this.state.dialogType === EDGE_MODEL_DIALOG && <LinkEdgeNumberModal submission={this.state.selectedSubmission} broker={this.state.selectedBroker} onHide={this.handleCloseModal} refetchSubmissions={this.props.refetchSubmissions} />}
            {this.state.dialogType === DENY_SUBMISSION_ACCESS_DIALOG && <Button onClick={this.handleCloseModal}>Continue</Button>}
            {this.state.dialogType === QUOTE_STATUS_DIALOG &&
              <ChangeQuoteStatusModal 
                selectedSubmissionRow={this.state.selectedSubmissionRow}
                onHide={this.handleCloseModal}
                refetchSubmissions={this.props.refetchSubmissions}
                loading={this.props.loading}
                isBound={this.state.statusModalIsSystemBound}
              />
            }
            {this.state.dialogType === SUBMISSION_HISTORY_DIALOG &&
              <SubmissionHistoryModal 
                selectedSubmissionRow={this.state.selectedSubmissionRow}
                onHide={this.handleCloseModal}
                isUnderwriter={this.props.isUnderwriter}
              />
            }
          </DialogBox>
          
          <DialogBox
            custom_class="confirmationDialog"
            title={this.state.modelUnBindTitle}
            subtitle="This will allow quote revisions and binder re-submission."
            show={this.state.showUnBindModal}
            onHide={this.handleCloseUnBindModal}
          >
            <Button className="btn" onClick={this.handleConfirmUnBindModal}>Confirm</Button>
            <Button className="btn secondary" onClick={this.handleCloseUnBindModal}>Cancel</Button>
          </DialogBox>
         
          {this.state.isClickedOcp && this.state.submission && <OCPBinder isDashboardBinder={true} handleOcpBind={this.handleOcpBind} submission={this.state.submission} user={this.props.user} underwriter={this.props.underwriter} isUnderwriter={isUnderwriter} isActiveBrokerage ={this.state.isActiveBrokerage}/>}
          {this.state.isClicked && <PDFPreview custom_class="confirmationDialog" submissionid={this.state.submissionid} show={this.state.showPdf} onHide={this.handleHidePdf} />}
          {this.state.isClickedQuote && <PDFPreviewQuoteSpecimen submissionid={this.state.submissionid} show={this.state.showPdf} onHide={this.handleHidePdf} />}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  brokerages: state.brokerages,
  workflowStatusChange: state.app.workflowStatusChange,
  bindStatusChange: state.app.bindStatusChange,
  manualQuoteStatusUpdatedList: state.app.manualQuoteStatusUpdatedList
})

export default connect(mapStateToProps, { updateSubmission, unlockBind, fetchBrokerages })(SubmissionsListFeedTable)
